import { BundleResourcesPackage } from "resource-system";
import { Spritesheet } from "pixi.js";
import { Texture } from "@pixi/core";
export class MenuResourcesPackage extends BundleResourcesPackage {
    public constructor() {
        super("MenuResourcesPackage");
    }
    public get assets_menu_menu_1x_atlas_json(): Spritesheet {
        return this.resource<Spritesheet>("assets/menu/menu_1x.atlas.json");
    }
    public get assets_menu_play_button_png(): Texture {
        return this.assets_menu_menu_1x_atlas_json.textures["play_button.png"];
    }
    public get assets_menu_settings_button_png(): Texture {
        return this.assets_menu_menu_1x_atlas_json.textures["settings_button.png"];
    }
    public get assets_menu_menu_1x_atlas_png(): Texture {
        return this.resource<Texture>("assets/menu/menu_1x.atlas.png");
    }
}

